import DetachedDropdown from '@99designs/common/jquery-plugins/detached-dropdown/index';

// create all detached Dropdowns
DetachedDropdown.createAll('[data-detached-dropdown]');
